import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type ContainerStationContainerDetailFragment = { __typename?: 'ContainerStationContainer', id: string, name: string, owner_since: string, owner_till?: string | null, type_id: number, type_name: string, image_url?: string | null, size_helper?: string | null, status: Types.ContainerLocationStatus };

export const ContainerStationContainerDetailFragmentDoc = gql`
    fragment ContainerStationContainerDetail on ContainerStationContainer {
  id
  name
  owner_since
  owner_till
  type_id
  type_name
  image_url
  size_helper
  status
}
    `;